import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import i18n from "../../../../constants/i18n";
import getWorkloadStore from "../../../../stores/auditor-store/workload-store";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Date from "../../../../core/et3-input/et3-date";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const WorkloadDataForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MIN")}
          dateInputObservable={getWorkloadStore().dateMinInput}
          isEnabled={true}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MAX")}
          dateInputObservable={getWorkloadStore().dateMaxInput}
          isEnabled={true}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={true}
        onClick={async () => {
          await getWorkloadStore().getWorkloadData();
        }}
        size="LARGE"
        type="GET"
        text="GET"
      />
    </React.Fragment>
  );
});
export default WorkloadDataForm;
